// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/bundle." + chunkId + ".min.js?" + "254eb3a2c6db7459add2" + "";
};